import SectionSummaryTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/SectionSummaryTable/SectionSummaryTable";

export default SectionSummaryTable;
